export enum EditMode {
  CREATE,
  EDIT,
  CONFIRM,
}
